import $ from "jquery";

export function setup_page()
{
    $(window).on("scroll", function() {
        let scroll_top = $(window).scrollTop();
        let body = $("body");
        if (scroll_top > 0) {
            body.addClass("scrolled");
        } else {
            body.removeClass("scrolled");
        }
    });

    //Call it on page load
    $(window).scroll();
}

export function home_animation()
{
    let delay = 200;

    function fade_in_projects()
    {
        let projects = $('.card-project');
        console.log(projects.length);

        projects.each(function(i)
        {
            let _this = $(this);

            setTimeout(function() {
                _this.addClass('active');

                if (i == projects.length - 1)
                {
                    fade_out_logo();
                }

            }, i * 100);
        });
    }

    function fade_out_logo()
    {
        $('body').addClass('animation__grid-fadedin');
    }

    setTimeout(function() {
        $('body.home').addClass('animation__intro');
    }, 0 + delay );

    setTimeout(function() {
        fade_in_projects();
    }, 2000 + delay );
}

export function setup_infopanel() {

    let trigger = $('.project__trigger');

    $('.project__trigger').on('click', function()
    {

        if($('.panel').hasClass('active'))
        {
            $('.panel').removeClass('active');
            trigger.find('div').text('Project Information');
        }
        else
        {
            $('.panel').addClass('active');
            trigger.find('div').text('Close');
        }

    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/modules/page.js